import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53027786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manga-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "继续阅读", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(['manga-list-box', { block: $setup.config.viewType === 'list' }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lastReadList, (item) => {
        return (_openBlock(), _createBlock($setup["manga"], {
          key: item.lastReadId,
          viewType: $setup.config.viewType,
          mangaInfo: item
        }, null, 8 /* PROPS */, ["viewType", "mangaInfo"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ]))
}